import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e57ba0e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "meter" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"cover\" data-v-1e57ba0e></div><div class=\"directions\" data-v-1e57ba0e><div class=\"east\" data-v-1e57ba0e>東</div><div class=\"west\" data-v-1e57ba0e>西</div><div class=\"north\" data-v-1e57ba0e>北</div><div class=\"south\" data-v-1e57ba0e>南</div></div>", 2)
const _hoisted_4 = { class: "direction" }
const _hoisted_5 = { class: "value" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "unit" }, "m/s", -1))

import { computed } from 'vue'
import { windDirectionLabel } from '@/lib/constants'

type WindMeterProps = {
  windDirection?: number
  windStrength?: string
  size?: string
}


export default /*#__PURE__*/_defineComponent({
  props: {
    windDirection: null,
    windStrength: null,
    size: null
  },
  setup(__props: any) {

const props = __props as {
  windDirection?: number
  windStrength?: string
  size?: string
}


const windDirectionText = computed(() => {
  return windDirectionLabel(props.windDirection)
})
const windPointerStyle = computed(() => {
  if (props.windDirection === undefined || props.windDirection === 0) {
    return {
      display: 'none',
    }
  }

  const deg = Number(props.windDirection) * 22.5
  const rotate = `rotate(${deg}deg)`

  return {
    transform: rotate,
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([__props.size, "wind-panel"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        style: _normalizeStyle(_unref(windPointerStyle)),
        class: "pointer"
      }, null, 4),
      _hoisted_2
    ]),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(windDirectionText)), 1),
    _createElementVNode("div", _hoisted_5, _toDisplayString(__props.windStrength), 1),
    _hoisted_6
  ], 2))
}
}

})